import { useEffect, useState } from "react";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";
import AgentsListSearch from "./AgentsListSearch";

const AgentsList = (props) => {
  const { status } = props;
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState({
    page: 1,
    // limit: 10,
  });
  const [rowcount, setRowcount] = useState(0);
  const [agentId, setAgentId] = useState(null);
  const [data, setData] = useState([]);
  const columns = [
    {
      dataIndex: "agent_name",
      title: "Agent Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "email_address",
      title: "Email",
    },
    {
      dataIndex: "work_location",
      title: "Location",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];
  // ----------------------------------------------------------------

  const modalConfigs = {
    agentList: [
      {
        name: "agent_name",
        label: "Agent Name",
        type: "text",
        required: true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        name: "email_address",
        label: "Email ID",
        type: "email",
        rules: _enum.EMAIL_RULE,
        required: true,
      },
      {
        name: "work_location",
        label: "Work Location",
        type: "select",
        options: [],
        fetchKey: "location_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetMasterLocations();
          if (data) return data?.options("location_name");
          return [];
        },
      },
      {
        name: "state",
        label: "State",
        type: "text",
        readOnly: true,
      },
      {
        name: "city",
        label: "City",
        type: "text",
        readOnly: true,
      },
      {
        name: "onboarding_date",
        label: "Onboarding Date",
        type: "date",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.EMPLOYEE_STATUS,
      },
    ],
  };
  const dependencies = {
    work_location: async (value) => {
      if (value) {
        const res = await props.apis.apiGetLocationByName({
          location_name: value,
        });
        if (res) {
          return {
            valueUpdates: {
              state: res?.state,
              city: res?.city,
            },
          };
        }
      }
      return {};
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const openApplicationModal = () => {
    let defaultValues = {};
    openModal("agentList", "add", "Add Agent", defaultValues);
  };

  const view = async (record) => {
    const data = await props.apis.apiGetAgentById({
      agent_id: record.agent_id,
    });
    openModal("agentList", "view", "View Agent", { ...data });
  };

  const edit = async (record) => {
    const data = await props.apis.apiGetAgentById({
      agent_id: record.agent_id,
    });
    setAgentId(record.agent_id);
    openModal("agentList", "edit", "Edit Agent", { ...data });
  };

  const deleteAgent = (record) => {
    swal2
      .fire({
        title: "Are you sure you want to delete this Agent?",
        icon: "info",
        iconColor: "#234C9B",
        showCancelButton: true,
        confirmButtonColor: "#234C9B",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiDeleteAgent({ agent_id: record.agent_id })
            .then((res) => {
              swal2.fire({
                title: "Agent Deleted",
                text: "Agent deleted successfully !!",
                icon: "success",
                iconColor: "#234C9B",
                timer: 4000,
              });
              getData();
            });
        }
      });
  };

  const handleAppModalSubmit = async (data) => {
    if (modalState.mode === "edit" && modalState.type === "agentList") {
      let payload = {
        ...data,
      };
      const res = await props.apis.apiUpdateAgent(payload, {
        agent_id: agentId,
      });
      if (res) {
        swal2.fire({
          title: "Agent updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    } else if (modalState.mode === "add") {
      const res = await props.apis.apiAddAgent(data);
      if (res) {
        swal2.fire({
          title: "Agent added successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    }
  };
  // ----------------------------------------------------------------

  const getData = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis
      .apiGetAgents({
        ...payload,
      })
      .then(({ data, count }) => {
        setData(data);
        setRowcount(count);
        setIsFetching(false);
      });
  };

  const onSearch = (data, reset) => {
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };
  // ----------------------------------------------------------------
  useEffect(() => {
    // whenever tab changes AND this wrapper is active → call API
    if (props.activeKey === status.toLowerCase()) {
      getData();
    }
  }, [props.activeKey, status]);
  return (
    <>
      <div className="d-flex align-items-center justify-content-end mb-3 float_top_lg top-60px">
        <AgentsListSearch
          onSearch={(...arg) => onSearch(...arg)}
          openApplicationModal={openApplicationModal}
        />
      </div>
      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        viewAction={(e) => view(e)}
        editAction={(e) => edit(e)}
        deleteAction={(e) => deleteAgent(e)}
        loading={isFetching}
      ></AppTable>

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />
    </>
  );
};

export default constore(AgentsList);
